import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "hospital",
            component:() =>  import ("./components/pages/p-root/p-root"),
            children: [
                {
                    path: "terminal-:terminalCode*",
                    name: "terminal.root.legacy",
                    redirect: (to) => `/map-79962313/terminal-${to.params.terminalCode}/start`,
                },
                {
                    path: "terminal-:terminalCode/start",
                    name: "terminal.start.legacy",
                    redirect: (to) => `/map-79962313/terminal-${to.params.terminalCode}/start`,
                },
                {
                    path: "map-:mapId/terminal-:terminalCode",
                    name: "terminal.root",
                    component:() =>  import ("./components/pages/p-terminal/p-terminal"),
                    props: true,
                    redirect: {name:"terminal.start"},
                    children: [
                        {
                            path: "start",
                            name: "terminal.start",
                            component: () =>
                                import("./components/unique-organisms/o-start/o-start")
                        },
                        {
                            path: "services",
                            name: "terminal.service",
                            component: () =>
                                import("./components/unique-organisms/o-services/o-services")
                        },
                        {
                            path: "care",
                            name: "terminal.care",
                            component: () =>
                                import("./components/unique-organisms/o-care/o-care")
                        },
                        {
                            path: "search",
                            name: "terminal.search",
                            component: () =>
                                import("./components/unique-organisms/o-search/o-search")
                        },
                        {
                            path: "guide/:type/id-:id",
                            name: "terminal.guide",
                            component: () =>
                                import("./components/unique-organisms/o-guide/o-guide")
                        }
                    ]
                },
                {
                    path: 'map-:mapId',
                    name: 'detect.theme',
                    component:() =>  import ("./components/pages/p-define-theme/p-define-theme"),
                    props: true,
                    children: [
                        {
                            path: 'web',
                            name: 'web.root',
                            component:() =>  import ("./components/pages/p-desktop/p-desktop"),
                            redirect: 'web/start',
                            children: [
                                {
                                    path: 'start',
                                    name: 'web.start',
                                    component:() =>  import ("./components/unique-organisms/o-d-start/o-d-start")
                                },
                                {
                                    path: 'care',
                                    name: 'web.care',
                                    component:() =>  import ("./components/unique-organisms/o-d-care/o-d-care")
                                },
                                {
                                    path: 'services',
                                    name: 'web.services',
                                    component:() =>  import ("./components/unique-organisms/o-d-services/o-d-services")
                                },
                                {
                                    path: 'service',
                                    name: 'web.service',
                                    component: () => import ("./components/unique-organisms/o-d-service/o-d-service")
                                },
                                {
                                    path: 'guide/:type',
                                    name: 'web.guide',
                                    component:() =>  import ("./components/unique-organisms/o-d-guide/o-d-guide")
                                }
                            ]
                        },
                        {
                            path: "mobile",
                            name: "mobile.root",
                            component:() =>  import ("./components/pages/p-mobile/p-mobile"),
                            children: [
                                {
                                    path: 'service',
                                    name: 'mobile.services',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-services/o-mobile-services")
                                },
                                {
                                    path: "services",
                                    name: "mobile.service",
                                    component: () => import ("./components/unique-organisms/o-m-service/o-m-service")
                                },
                                {
                                    path: 'care',
                                    name: 'mobile.care',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-care/o-mobile-care")
                                },
                                {
                                    path: 'plan',
                                    name: 'mobile.plan',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-plan/o-mobile-plan")
                                },
                                {
                                    path: ':from/searchbar',
                                    name: 'mobile.searchbar',
                                    component:() =>  import ("./components/unique-organisms/o-m-searchbar/o-m-searchbar")
                                },
                                {
                                    path: 'guide/:type',
                                    name: 'mobile.guide',
                                    component:() =>  import ("./components/unique-organisms/o-mobile-guide/o-mobile-guide")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'qr-:qrId',
                    name: 'qr.controller',
                    component:() =>  import ("./components/pages/p-qr-controller/p-qr-controller"),
                    props: true
                }
            ]
        },
        { 
            path: '*', 
            redirect: '/map-79962313/' 
        }
    ]
});
